import React from 'react';
import { BoxProps } from '@mui/material';
import { Info } from '@mui/icons-material';

import { BodyMedium, Row, TitleSmall } from '@dh/styles';
import { useTheme } from '@dh/hooks';

import { StyledHint } from './styles';

interface Props extends BoxProps {
    text: string;
    children?: React.ReactNode;
}

export const Hint = ({ text, children, ...boxProps }: Props) => {
    const { colors } = useTheme();
    return (
        <StyledHint {...boxProps}>
            <Row gap={1} sx={{ p: 2, verticalAlign: 'center' }}>
                <Info sx={{ color: colors.primary60 }} />
                <TitleSmall>{text}</TitleSmall>
            </Row>
            {!!children && (
                <BodyMedium sx={{ p: 2, backgroundColor: colors.white }}>{children}</BodyMedium>
            )}
        </StyledHint>
    );
};
